import React, { memo, useMemo } from 'react';
import { FixedSizeList as List, type ListChildComponentProps } from 'react-window';
import { useElementSize } from '../../hooks/useElementSize';
import { UploadRow } from '../../utils/uploadTypes';
import FileItem from './FileItem';

interface FileListProps {
  rows: UploadRow[];
  /** Index into the UNFILTERED row array, so the toggle cannot shift the marker. */
  activeIndex: number;
  indices: number[];
}

interface RowData {
  rows: UploadRow[];
  indices: number[];
  activeIndex: number;
}

const ITEM_HEIGHT = 80;
const OVERSCAN_COUNT = 5;

function Row({ index, style, data }: ListChildComponentProps<RowData>) {
  const { rows, indices, activeIndex } = data as RowData;
  const rowIndex = indices[index];

  return (
    <div style={style}>
      <FileItem
        row={rows[rowIndex]}
        isCurrentFile={rowIndex === activeIndex}
      />
    </div>
  );
}

const FileList = memo(({ rows, activeIndex, indices }: FileListProps) => {
  const [ref, { height, width }] = useElementSize<HTMLDivElement>();

  const itemData = useMemo<RowData>(
    () => ({ rows, indices, activeIndex }),
    [rows, indices, activeIndex]
  );

  return (
    <div
      ref={ref}
      className="min-h-0 flex-1"
      data-cy="sycai-upload-list"
    >
      {height > 0 && (
        <List
          height={height}
          width={width}
          itemCount={indices.length}
          itemSize={ITEM_HEIGHT}
          itemData={itemData}
          overscanCount={OVERSCAN_COUNT}
        >
          {Row}
        </List>
      )}
    </div>
  );
});

FileList.displayName = 'FileList';

export default FileList;
